<template>
  <div class="pos-container p-3">
    <div class="container-fluid">

      <!-- Yuqori panel: Kechiktirilganlar ro'yxati -->
      <div class="d-flex justify-content-end mb-2">
        <button class="btn btn-park-list" @click="openParkedModal">
          ⏸ Kechiktirilganlar
          <span v-if="parkedList.length" class="badge bg-danger ms-1">{{ parkedList.length }}</span>
        </button>
      </div>

      <div class="row g-3">

        <!-- CHAP TOMON: Header + Mahsulotlar -->
        <div class="col-lg-8">
          <SaleHeaderBar
            :form.sync="form"
            :clientList="clientList"
            :ustaList="ustaList"
            :bronList="bronList"
            :clientCars="clientCars"
            :saleType="saleType"
            @client-changed="onClientChange"
            @master-changed="onMasterChange"
            @bron-selected="onBronSelect"
            @car-selected="onCarSelected"
            @client-added="onClientAdded"
            @car-added="onCarAdded"
            @sale-type-changed="onSaleTypeChanged"
          />

          <ProductBrowser
            :saleType="saleType"
            :currencyMode="form.currency_mode"
            :dollarRate="dollarRate"
            :cart="cart"
            @select-package="selectPackage"
            @add-product="addProductToCart"
            @decrease-product="decreaseQty"
            @decrease-service="decreaseQty"
            @remove-item="removeFromCart"
          />
        </div>

        <!-- O'NG TOMON: Savatcha va To'lov -->
        <div class="col-lg-4">
          <SaleCartSidebar
            :cart="cart"
            :form.sync="form"
            :saleType="saleType"
            :currencyMode="form.currency_mode"
            :totalSum="totalSum"
            :productSumma="productSumma"
            :serviceSumma="serviceSumma"
            :paidTotal="paidTotal"
            :masterPercent="masterPercent"
            :masterSumma="masterSumma"
            :loading="loading"
            :parking="parking"
            :clientDebt="clientDebt"
            :clientDebtSom="clientDebtSom"
            :clientDebtDollar="clientDebtDollar"
            :paytypes="paytypes"
            :dollarRate="dollarRate"
            @remove-item="removeFromCart"
            @increase-qty="increaseQty"
            @decrease-qty="decreaseQty"
            @clear-all="clearAll"
            @clear-services="clearServices"
            @pay-cash="payAllCash"
            @pay-plastic="payAllPlastic"
            @pay-debt="payClientDebt"
            @submit="submitSale"
            @park="parkSale"
          />
        </div>

      </div>
    </div>

    <!-- Chek modali -->
    <SaleReceiptModal
      :show="receipt.show"
      :firmName="receipt.firmName"
      :phone="receipt.phone"
      :checkWord="receipt.checkWord"
      :logoUrl="receipt.logoUrl"
      :clientName="receipt.clientName"
      :masterName="receipt.masterName"
      :carNumber="receipt.carNumber"
      :cart="receipt.cart"
      :totalSum="receipt.totalSum"
      :skidka="receipt.skidka"
      :cashSumma="receipt.cashSumma"
      :plasticSumma="receipt.plasticSumma"
      :shotSumma="receipt.shotSumma"
      :payTable="receipt.payTable"
      :paytypes="paytypes"
      :dollarRate="receipt.dollarRate"
      :currencyMode="receipt.currencyMode"
      :refundMoney="receipt.refundMoney"
      :prevDebt="receipt.prevDebt"
      :prevDebtDollar="receipt.prevDebtDollar"
      :nasiyaDate="receipt.nasiyaDate"
      @close="closeReceipt"
    />

    <!-- Kechiktirilgan savdolar ro'yxati -->
    <ParkedSalesModal
      ref="parkedModal"
      :list="parkedList"
      :loading="parkedLoading"
      :busyId="parkBusyId"
      @resume="resumeParked"
      @delete="deleteParked"
    />
  </div>
</template>

<script>
import axios from 'axios';
import SaleHeaderBar from './components/SaleHeaderBar.vue';
import ProductBrowser from './components/ProductBrowser.vue';
import SaleCartSidebar from './components/SaleCartSidebar.vue';
import SaleReceiptModal from './components/SaleReceiptModal.vue';
import ParkedSalesModal from './components/ParkedSalesModal.vue';

export default {
  name: 'ChiqimPos',
  components: { SaleHeaderBar, ProductBrowser, SaleCartSidebar, SaleReceiptModal, ParkedSalesModal },

  data() {
    return {
      loading: false,
      priceUpdates: 0,
      priceUpdateFailed: false,
      clientList: [],
      ustaList: [],
      bronList: [],
      clientCars: [],
      paytypes: [],
      packageTypes: [],
      dollarRate: 1,
      cart: [],          // unified: { type:'product'|'service', id, name, price?, labor_price?, redo_price?, qty }
      saleType: 'chakana', // 'chakana' yoki 'optom'
      masterPercent: 0,
      clientDebt: 0,
      clientDebtSom: 0,    // mijozning so'mdagi qarzi
      clientDebtDollar: 0, // mijozning dollardagi qarzi ($, price_type=3)

      // Kechiktirilgan (parked / hold) savdolar
      parkedList: [],
      parkedLoading: false,
      parking: false,
      parkBusyId: null,

      // Sklad sozlamalari (chek uchun)
      skladSettings: {
        firmName: '',
        phone: '',
        checkWord: '',
        logoUrl: '',
      },

      // Chek modal ma'lumotlari
      receipt: {
        show: false,
        firmName: '',
        phone: '',
        checkWord: '',
        logoUrl: '',
        clientName: "NOMA'LUM",
        masterName: '',
        carNumber: '',
        cart: [],
        totalSum: 0,
        skidka: 0,
        cashSumma: 0,
        plasticSumma: 0,
        shotSumma: 0,
        payTable: [],
        dollarRate: 1,
        refundMoney: 0,
        prevDebt: 0,
        prevDebtDollar: 0,
        nasiyaDate: '',
        currencyMode: 'som',
      },

      form: {
        kontragent_id: null,
        master_user_id: null,
        bron_id: null,
        car_number: '',
        comment: '',
        skidka_summa: 0,
        cash_summa: 0,
        plastic_summa: 0,
        shot_summa: 0,
        dollar_summa: 0,
        dollar_rate: 1,
        pay_table: [],
        // Custom (tizimda yaratilgan) pay_type lar uchun: { [pay_type_id]: summa }
        pay_table_amounts: {},
        qarz_dollar: 0,
        currency_mode: 'som',
        nasiya_date: '',
      },
    };
  },

  computed: {
    productSumma() {
      return this.cart
        .filter(i => i.type === 'product')
        .reduce((sum, i) => sum + this.productSomPrice(i) * Number(i.qty), 0);
    },
    serviceSumma() {
      return this.cart
        .filter(i => i.type === 'service')
        .reduce((sum, i) => {
          let price = 0;
          if (this.saleType === 'optom') {
            price = Number(i.labor_price_optom || 0) + Number(i.redo_price_optom || 0);
          } else {
            price = Number(i.labor_price_chakana || 0) + Number(i.redo_price_chakana || 0);
          }
          return sum + price * Number(i.qty);
        }, 0);
    },
    // Faqat ish haqi (labor_price) — peredelka (redo_price) usta bonusiga kirmaydi
    serviceLaborSumma() {
      return this.cart
        .filter(i => i.type === 'service')
        .reduce((sum, i) => {
          const price = this.saleType === 'optom'
            ? Number(i.labor_price_optom || 0)
            : Number(i.labor_price_chakana || 0);
          return sum + price * Number(i.qty);
        }, 0);
    },
    totalSum() {
      return this.productSumma + this.serviceSumma - Number(this.form.skidka_summa || 0);
    },
    paidTotal() {
      // pay_table dan so'm ekvivalenti hisoblanadi (dollar kursga ko'paytirilgan)
      const rate = parseFloat(this.form.dollar_rate) || this.dollarRate || 1;
      return (this.form.pay_table || []).reduce((acc, r) => {
        const s = parseFloat(r.summa) || 0;
        if (s <= 0) return acc;
        if (parseInt(r.pay_type_id) === 3) return acc + s * rate;
        return acc + s;
      }, 0);
    },
    masterSumma() {
      return (this.serviceLaborSumma * this.masterPercent) / 100;
    },
  },

  mounted() {
    this.initData();
  },

  methods: {
    // Dollar rejimida mahsulot narxi dollar_price × kurs bo'yicha olinadi — aks holda
    // so'm narx kursga mos kelmay, JAMI ($) bilan qarz ($) har xil chiqardi.
    productSomPrice(item) {
      const dollar = Number(item.dollar_price || 0);
      if (this.form.currency_mode === 'dollar' && dollar > 0) {
        const rate = parseFloat(this.form.dollar_rate) || this.dollarRate || 1;
        return dollar * rate;
      }
      return Number(item.price || 0);
    },
    async initData() {
      await Promise.all([
        this.fetchClients(),
        this.fetchUstas(),
        this.fetchBrons(),
        this.fetchSkladSettings(),
        this.fetchPaytypes(),
        this.fetchDollarRate(),
        this.fetchParked(),
        this.fetchPackageTypes(),
      ]);

      const selectedBronId = localStorage.getItem('selected_bron_id');
      if (selectedBronId) {
        await this.onBronSelect(Number(selectedBronId), true);
        localStorage.removeItem('selected_bron_id');
      }
    },

    async fetchPaytypes() {
      try {
        const res = await axios.get('api/v1/pay-type');
        this.paytypes = res.data || [];
      } catch (e) { this.paytypes = []; }
    },
    async fetchPackageTypes() {
      try {
        const res = await axios.get('api/v1/package_types');
        this.packageTypes = res.data || [];
      } catch (e) { this.packageTypes = []; }
    },
    // Xizmat (repair_package) turi nomini id bo'yicha topish — chekda ba'zi
    // turlar (masalan "Peredelka zapchasti bilan") uchun maxsus ko'rinish kerak.
    packageTypeName(id) {
      const t = this.packageTypes.find(t => t.id === id);
      return t ? t.name : '';
    },
    async fetchDollarRate() {
      try {
        const res = await axios.get('api/v1/dollar-exchange-rate/last');
        const rate = parseFloat(res.data && res.data.rate) || 1;
        this.dollarRate = rate;
        this.form.dollar_rate = rate;
      } catch (e) { /* default 1 */ }
    },

    async fetchClients() {
      try {
        // Barcha mijozlar (oddiy + usta + zapchas + ta'minotchi) — hammasiga savdo qilish mumkin.
        // Avval faqat type=1 (oddiy mijoz) yuklanardi, shu sabab usta/zapchas mijozlar chiqmasdi.
        const res = await axios.get('api/v1/kontragent/');
        this.clientList = Array.isArray(res.data) ? res.data : (res.data && res.data.data) || [];
      } catch (e) { console.error("Mijozlarni yuklashda xato", e); }
    },
    async fetchUstas() {
      try {
        const res = await axios.get('api/v1/staff');
        this.ustaList = res.data?.data || [];
      } catch (e) { console.error("Ustalarni yuklashda xato", e); }
    },
    async fetchBrons() {
      try {
        const res = await axios.get('api/v1/service-sale/brons');
        this.bronList = res.data;
      } catch (e) { this.bronList = []; }
    },
    async fetchClientDebt(clientId) {
      if (!clientId) { this.clientDebt = 0; this.clientDebtSom = 0; this.clientDebtDollar = 0; return; }
      try {
        const res = await axios.post('api/v1/kontragent/total', { kontragent_id: clientId });
        const data = res.data || [];
        // Dollar qarz (pay_type_id=3, $ da) va so'm qarz alohida
        this.clientDebtDollar = data
          .filter(item => Number(item.pay_type_id) === 3)
          .reduce((sum, item) => sum + Number(item.total || 0), 0);
        this.clientDebtSom = data
          .filter(item => Number(item.pay_type_id) !== 3)
          .reduce((sum, item) => sum + Number(item.total || 0), 0);
        // Umumiy qarz so'm ekvivalentida (PaymentSplitter'ga "expected-total" sifatida beriladi) —
        // dollar qismi kursga ko'paytirilib qo'shiladi, aks holda $ va so'm to'g'ridan-to'g'ri
        // qo'shilib, dollar qarz noto'g'ri "so'm" deb ko'rsatilib qolar edi.
        const rate = Number(this.form.dollar_rate || this.dollarRate || 1);
        this.clientDebt = Math.abs(this.clientDebtSom + this.clientDebtDollar * rate);
      } catch (e) { this.clientDebt = 0; this.clientDebtSom = 0; this.clientDebtDollar = 0; }
    },

    async fetchSkladSettings() {
      const sklad_id = localStorage.getItem('sklad_id');
      if (!sklad_id) return;
      try {
        // Sklad asosiy ma'lumotlari (nomi, telefon, chek izohi)
        const [skladRes, settingsRes] = await Promise.all([
          axios.get(`api/v1/sklads/id/${sklad_id}`),
          axios.post('api/v1/sklad-settings', { sklad_id, key: 'a4_printer' }),
        ]);

        const sklad = skladRes.data?.data || skladRes.data || {};
        this.skladSettings.phone     = sklad.phone_number || '';
        this.skladSettings.checkWord = sklad.check_word   || '';

        // Firma nomini printer sozlamalaridan olish (yo'q bo'lsa sklad nomidan)
        const printerData = settingsRes.data?.data;
        if (printerData) {
          const parsed = JSON.parse(printerData);
          this.skladSettings.firmName = parsed?.sender?.firm_name || sklad.name || '';
          if (parsed?.file_name) {
            this.skladSettings.logoUrl = axios.defaults.baseURL + 'api/v1/uploads/' + parsed.file_name;
          }
        } else {
          this.skladSettings.firmName = sklad.name || '';
        }
      } catch (e) {
        console.error("Sklad sozlamalarini yuklashda xato", e);
      }
    },

    async onClientChange(id) {
      this.fetchClientDebt(id);
      this.fetchClientCars(id);
      // Mijozning sale_type ga qarab optom/chakana tanlash
      const client = this.clientList.find(c => c.id === id);
      await this.onSaleTypeChanged((client && client.sale_type) || 'chakana');
    },
    async fetchClientCars(clientId) {
      if (!clientId) { this.clientCars = []; return; }
      try {
        const res = await axios.get(`api/v1/client-profile/cars`, { params: { kontragent_id: clientId } });
        this.clientCars = res.data?.data || res.data || [];
      } catch (e) { this.clientCars = []; }
    },
    onCarSelected(car) {
      if (!car) {
        this.form.car_number = '';
        return;
      }
      this.form.car_number = car.car_number || '';
    },
    async onClientAdded(client) {
      await this.fetchClients();
      if (client?.id) {
        this.form.kontragent_id = client.id;
        await this.onClientChange(client.id);
      }
    },
    async onBronSelect(id, forceFetch = false) {
      if (!id) return;

      let bron = this.bronList.find(b => Number(b.id) === Number(id));
      if (forceFetch || !bron) {
        try {
          const res = await axios.get(`api/v1/bron/print/${id}`);
          bron = res.data;
        } catch (e) {
          alert("Zakaz ma'lumotlarini yuklab bo'lmadi");
          return;
        }
      }

      if (!bron) return;

      this.form.kontragent_id = bron.kontragent_id;
      this.form.bron_id = bron.id;
      this.form.comment = bron.comment || this.form.comment || '';
      // Bron tanlanganda ham mijozning sale_type ni o'rnatish
      const client = this.clientList.find(c => c.id === bron.kontragent_id);
      if (client && client.sale_type) {
        await this.onSaleTypeChanged(client.sale_type);
      }
      this.fetchClientDebt(bron.kontragent_id);
      this.fetchClientCars(bron.kontragent_id);

      const bronServices = this.buildBronServiceCart(bron);
      const serviceProductIds = new Set();
      bronServices.forEach(service => {
        (service.items || []).forEach(item => {
          if (item.product_id != null) serviceProductIds.add(Number(item.product_id));
        });
      });

      const bronProducts = (bron.products || [])
        .filter(p => !serviceProductIds.has(Number(p.product_id)))
        .map(p => ({
          id: p.product_id,
          name: p.product?.extra_name || p.product?.name || 'Mahsulot',
          price: Number(p.price || 0),
          qty: Number(p.count || 0),
          balance: 0,
          type: 'product',
        }));

      const serviceProducts = bronServices.flatMap(service =>
        (service.items || []).map(item => {
          const itemPrice = this.saleType === 'optom'
            ? Number(item.price_optom || 0)
            : Number(item.price_chakana || 0);
          const baseQty = Number(item.quantity || 1);
          return {
            id: item.product_id,
            name: item.product?.extra_name || item.product?.name || 'Mahsulot',
            price: itemPrice,
            price_chakana: Number(item.price_chakana || 0),
            price_optom: Number(item.price_optom || 0),
            qty: baseQty * Number(service.qty || 1),
            base_qty: baseQty,
            balance: 0,
            type: 'product',
            from_service: service.id,
          };
        })
      );

      this.cart = [...bronServices, ...serviceProducts, ...bronProducts];
    },
    buildBronServiceCart(bron) {
      const grouped = new Map();
      (bron.services || []).forEach(service => {
        const packageId = Number(service.package_id || service.repair_package_id || service.id || 0);
        const key = [
          packageId,
          service.name || '',
          service.labor_price_chakana || 0,
          service.redo_price_chakana || 0,
          service.labor_price_optom || 0,
          service.redo_price_optom || 0,
        ].join('|');

        if (!grouped.has(key)) {
          const packageTypeId = service.package_type_id
            || (service.repair_package && service.repair_package.package_type_id);
          grouped.set(key, {
            id: packageId,
            name: service.name || 'Xizmat',
            labor_price_chakana: Number(service.labor_price_chakana || 0),
            redo_price_chakana: Number(service.redo_price_chakana || 0),
            labor_price_optom: Number(service.labor_price_optom || 0),
            redo_price_optom: Number(service.redo_price_optom || 0),
            qty: 0,
            type: 'service',
            items: service.items || [],
            package_type_id: packageTypeId,
            package_type_name: this.packageTypeName(packageTypeId),
          });
        }
        const row = grouped.get(key);
        row.qty += 1;
        if ((!row.items || row.items.length === 0) && service.items) {
          row.items = service.items;
        }
      });

      return Array.from(grouped.values());
    },
    async onCarAdded(car) {
      if (this.form.kontragent_id) {
        await this.fetchClientCars(this.form.kontragent_id);
        if (car?.car_number) {
          this.form.car_number = car.car_number;
        }
      }
    },
    onMasterChange(id) {
      if (!id) { this.masterPercent = 0; return; }
      const usta = this.ustaList.find(u => u.id === id);
      this.masterPercent = usta ? (usta.percent || usta.bonus || 0) : 0;
    },
    selectPackage(pkg) {
      const exist = this.cart.find(c => c.type === 'service' && c.id === pkg.id);
      if (exist) {
        exist.qty++;
        // Xizmatga tegishli mahsulotlar sonini ham oshirish
        this.cart.forEach(c => {
          if (c.type === 'product' && c.from_service === pkg.id) {
            c.qty += c.base_qty;
          }
        });
      } else {
        this.cart.push({
          id: pkg.id,
          name: pkg.name,
          labor_price_chakana: Number(pkg.labor_price_chakana || 0),
          redo_price_chakana: Number(pkg.redo_price_chakana || 0),
          labor_price_optom: Number(pkg.labor_price_optom || 0),
          redo_price_optom: Number(pkg.redo_price_optom || 0),
          qty: 1,
          type: 'service',
          package_type_id: pkg.package_type_id,
          package_type_name: this.packageTypeName(pkg.package_type_id),
        });
        // Xizmatga tegishli mahsulotlarni savatga qo'shish
        if (pkg.items && pkg.items.length > 0) {
          for (const item of pkg.items) {
            // Ba'zi paketlarda mahsulotsiz (product_id=NULL) bo'sh qator saqlanib
            // qolgan — shuni qo'shsak savdoda "Noma'lum" mahsulot paydo bo'ladi.
            if (!item.product_id) continue;
            const itemPrice = this.saleType === 'optom'
              ? Number(item.price_optom || 0)
              : Number(item.price_chakana || 0);
            this.cart.push({
              id: item.product_id,
              name: (item.product?.extra_name || item.product?.name || 'Mahsulot'),
              price: itemPrice,
              price_chakana: Number(item.price_chakana || 0),
              price_optom: Number(item.price_optom || 0),
              qty: Number(item.quantity || 1),
              base_qty: Number(item.quantity || 1),
              balance: 0,
              type: 'product',
              from_service: pkg.id,
            });
          }
        }
      }
    },

    addProductToCart(product) {
      const pr = product.price_register;
      const price = pr
        ? (this.saleType === 'optom' ? Number(pr.optom_price || 0) : Number(pr.chakana_price || 0))
        : 0;
      const bal = Number(product.balance || 0);
      const exist = this.cart.find(c => c.type === 'product' && c.id === product.id && !c.from_service);
      const curQty = exist ? Number(exist.qty || 0) : 0;
      // Qoldiq yetarli emas — savatga qo'shishni cheklaymiz (reviziya ProductBrowser'da)
      if (curQty + 1 > bal) {
        alert("Qoldiq yetarli emas! Ombordagi haqiqiy miqdorni 'Reviziya' orqali to'g'rilang.");
        return;
      }
      if (exist) {
        exist.qty++;
      } else {
        this.cart.push({
          id: product.id,
          name: product.extra_name || product.name,
          price: price,
          price_register: pr,
          dollar_price: this.saleType === 'optom'
            ? Number(pr?.optom_dollar_price || 0)
            : Number(pr?.chakana_dollar_price || 0),
          qty: 1,
          balance: product.balance || 0,
          type: 'product',
        });
      }
    },
    async onSaleTypeChanged(type) {
      this.saleType = type;
      this.priceUpdates++;
      this.priceUpdateFailed = false;
      try {
        // Savatchadagi mahsulot narxlarini yangilash
        const sklad_id = localStorage.getItem('sklad_id');
        for (const item of this.cart) {
          if (item.type === 'product' && item.from_service) {
            // Xizmatga tegishli mahsulotlar - o'z narxlari bor
            item.price = this.saleType === 'optom' ? Number(item.price_optom || 0) : Number(item.price_chakana || 0);
          } else if (item.type === 'product') {
            try {
              const pr = item.price_register || (await axios.post('api/v1/product/price-balance', {
                product_id: item.id,
                sklad_id: Number(sklad_id),
              })).data;
              item.price = this.saleType === 'optom' ? Number(pr.optom_price || 0) : Number(pr.chakana_price || 0);
              item.dollar_price = this.saleType === 'optom'
                ? Number(pr.optom_dollar_price || 0)
                : Number(pr.chakana_dollar_price || 0);
            } catch (e) {
              this.priceUpdateFailed = true;
              console.error("Narxni yangilashda xato", e);
            }
          }
        }
      } finally {
        this.priceUpdates--;
      }
    },

    increaseQty(item) {
      // To'g'ridan-to'g'ri mahsulot (xizmatga tegishli/bron emas) qoldiqdan oshmasin.
      // balance > 0 bo'lgan mahsulotlargagina cheklov — bron/xizmat (balance 0) buzilmaydi.
      if (item.type === 'product' && !item.from_service && Number(item.balance) > 0
          && Number(item.qty) + 1 > Number(item.balance)) {
        alert("Qoldiq yetarli emas! 'Reviziya' orqali ombordagi miqdorni to'g'rilang.");
        return;
      }
      item.qty++;
      // Xizmat qty oshganda tegishli mahsulotlar ham oshishi kerak
      if (item.type === 'service') {
        this.cart.forEach(c => {
          if (c.type === 'product' && c.from_service === item.id) {
            c.qty += c.base_qty;
          }
        });
      }
    },
    decreaseQty(item) {
      if (item.qty > 1) {
        item.qty--;
        // Xizmat qty kamaytirilganda tegishli mahsulotlar ham kamayishi kerak
        if (item.type === 'service') {
          this.cart.forEach(c => {
            if (c.type === 'product' && c.from_service === item.id) {
              c.qty -= c.base_qty;
              if (c.qty < c.base_qty) c.qty = c.base_qty;
            }
          });
        }
      }
    },
    removeFromCart(idx) {
      const item = this.cart[idx];
      if (item && item.type === 'service') {
        // Xizmatga tegishli mahsulotlarni ham o'chirish
        this.cart = this.cart.filter((c, i) => i !== idx && c.from_service !== item.id);
      } else {
        this.cart.splice(idx, 1);
      }
    },

    clearServices() {
      this.cart = this.cart.filter(i => i.type !== 'service' && !i.from_service);
    },
    clearAll() {
      this.cart = [];
      this.form = {
        ...this.form,
        bron_id: null,
        skidka_summa: 0,
        cash_summa: 0,
        plastic_summa: 0,
        shot_summa: 0,
        dollar_summa: 0,
        pay_table: [],
        pay_table_amounts: {}, // custom turlarni tozalash
        qarz_dollar: 0,
        nasiya_date: '',
      };
    },

    payAllCash() {
      this.form = {
        ...this.form,
        cash_summa: this.totalSum,
        plastic_summa: 0,
        shot_summa: 0,
        dollar_summa: 0,
        pay_table_amounts: {},
        pay_table: this.totalSum > 0 ? [{ pay_type_id: 1, summa: this.totalSum }] : [],
      };
    },
    payAllPlastic() {
      this.form = {
        ...this.form,
        plastic_summa: this.totalSum,
        cash_summa: 0,
        shot_summa: 0,
        dollar_summa: 0,
        pay_table_amounts: {},
        pay_table: this.totalSum > 0 ? [{ pay_type_id: 2, summa: this.totalSum }] : [],
      };
    },

    async payClientDebt(payment) {
      const done = typeof payment.done === 'function' ? payment.done : () => {};
      if (!this.form.kontragent_id) {
        alert("Mijoz tanlanmagan!");
        done(false);
        return;
      }

      const payTable = Array.isArray(payment.pay_table) ? payment.pay_table : [];
      const rate = Number(this.form.dollar_rate || this.dollarRate || 1);
      const totalSom = payTable.reduce((sum, row) => {
        const amount = Number(row.summa || 0);
        return sum + (Number(row.pay_type_id) === 3 ? amount * rate : amount);
      }, 0);

      if (totalSom <= 0 || totalSom > Number(this.clientDebt || 0) + 0.01) {
        alert("To'lov summasi mijoz qarzidan oshmasligi kerak");
        done(false);
        return;
      }

      try {
        const numberRes = await axios.get('api/v1/kontragent-pay/last-number');
        const number = numberRes.data?.number || numberRes.data || null;
        await axios.post('api/v1/kontragent-pay', {
          datetime: Math.floor(Date.now() / 1000),
          sklad_id: Number(localStorage.getItem('sklad_id')),
          kontragent_id: this.form.kontragent_id,
          summa: totalSom,
          current_total: 0,
          current_total_dollar: 0,
          pay_type_id: 1,
          type: true,
          number,
          dollar_rate: rate,
          pay_type_kassa: 1,
          kassa_summa: 0,
          qaytim_som: 0,
          qaytim_dollar: 0,
          comment: "Savdo oynasidan qarz to'lovi",
          pay_table: payTable,
        });
        alert("To'lov qabul qilindi");
        await this.fetchClientDebt(this.form.kontragent_id);
        done(true);
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "To'lovni saqlab bo'lmadi"));
        done(false);
      }
    },

    showReceipt() {
      const client = this.clientList.find(c => c.id === this.form.kontragent_id);
      const usta   = this.ustaList.find(u => u.id === this.form.master_user_id);

      this.receipt = {
        show:         true,
        firmName:     this.skladSettings.firmName,
        phone:        this.skladSettings.phone,
        checkWord:    this.skladSettings.checkWord,
        logoUrl:      this.skladSettings.logoUrl,
        clientName:   client ? client.name : "NOMA'LUM",
        masterName:   usta ? usta.name : '',
        carNumber:    this.form.car_number || '',
        cart:         JSON.parse(JSON.stringify(this.cart)).map(item => {
          if (item.type === 'product') {
            item.price = this.productSomPrice(item);
          }
          if (item.type === 'service') {
            // Chekda faqat tanlangan narx turini ko'rsatish
            if (this.saleType === 'optom') {
              item.labor_price = Number(item.labor_price_optom || 0);
              item.redo_price = Number(item.redo_price_optom || 0);
            } else {
              item.labor_price = Number(item.labor_price_chakana || 0);
              item.redo_price = Number(item.redo_price_chakana || 0);
            }
          }
          return item;
        }),
        totalSum:     this.totalSum,
        skidka:       Number(this.form.skidka_summa || 0),
        cashSumma:    Number(this.form.cash_summa    || 0),
        plasticSumma: Number(this.form.plastic_summa || 0),
        shotSumma:    Number(this.form.shot_summa    || 0),
        // N-ta to'lov turi + qarz
        payTable:     JSON.parse(JSON.stringify(this.form.pay_table || [])),
        dollarRate:   Number(this.form.dollar_rate || this.dollarRate || 1),
        refundMoney:  Number(this.form.dollar_summa || 0) > 0
          ? Math.max(0, Number(this.paidTotal || 0) - Number(this.totalSum || 0))
          : 0,
        // Mijozning savdodan oldingi qarzi (clientDebt — mijozda qancha qarz bor edi)
        prevDebt:       Number(this.clientDebtSom || 0),
        prevDebtDollar: Number(this.clientDebtDollar || 0),
        nasiyaDate:   this.form.nasiya_date || '',
        currencyMode:  this.form.currency_mode || 'som',
      };
    },

    closeReceipt() {
      this.receipt.show = false;
      this.clearAll();
      this.form.kontragent_id  = null;
      this.form.master_user_id = null;
      this.form.car_number     = '';
      this.form.comment        = '';
      this.fetchBrons();
    },

    async submitSale() {
      if (this.priceUpdates > 0 || this.priceUpdateFailed) {
        return alert(this.priceUpdates > 0
          ? "Narxlar yangilanmoqda. Biroz kuting."
          : "Narxlarni yuklab bo'lmadi. Savdo turini qayta tanlang.");
      }
      if (this.cart.length === 0) {
        return alert("Savatcha bo'sh!");
      }

      // Qarzga berishda YOKI bron/zakazdan kelib tushganda mijoz tanlash MAJBURIY
      // (usta tanlash ixtiyoriy bo'lib qoladi, bu shart o'zgarmaydi)
      const debt = Math.max(0, Number(this.totalSum || 0) - Number(this.paidTotal || 0));
      if ((debt > 0 || this.form.bron_id) && !this.form.kontragent_id) {
        alert(this.form.bron_id && debt <= 0
          ? "Zakazdan savdo qilishda mijoz tanlash majburiy!"
          : "Qarzga berish uchun mijoz tanlash majburiy!");
        // Mijoz tanlash inputiga fokus berish (agar mavjud bo'lsa)
        this.$nextTick(() => {
          const sel = document.querySelector('.client-select input, .client-select .vs__search');
          if (sel) sel.focus();
        });
        return;
      }

      this.loading = true;
      try {
        const sklad_id = localStorage.getItem('sklad_id');

        const services = this.cart
          .filter(i => i.type === 'service')
          .flatMap(srv =>
            Array(Number(srv.qty)).fill(null).map(() => ({
              repair_package_id: srv.id,
              name: srv.name,
              labor_price_chakana: srv.labor_price_chakana,
              redo_price_chakana: srv.redo_price_chakana,
              labor_price_optom: srv.labor_price_optom,
              redo_price_optom: srv.redo_price_optom,
            }))
          );

        const items = this.cart
          .filter(i => i.type === 'product' && !i.from_service)
          .map(i => ({
            product_id: i.id,
            count: i.qty,
            price: this.productSomPrice(i),
            summa: this.productSomPrice(i) * i.qty,
          }));

        const payload = {
          kontragent_id:  this.form.kontragent_id,
          master_user_id: this.form.master_user_id,
          bron_id:        this.form.bron_id,
          car_number:     this.form.car_number,
          comment:        this.form.comment,
          skidka_summa:   Number(this.form.skidka_summa  || 0),
          cash_summa:     Number(this.form.cash_summa    || 0),
          plastic_summa:  Number(this.form.plastic_summa || 0),
          shot_summa:     Number(this.form.shot_summa    || 0),
          dollar_summa:   Number(this.form.dollar_summa  || 0),
          dollar_rate:    Number(this.form.dollar_rate || this.dollarRate || 1),
          pay_table:      this.form.pay_table || [],
          qarz_dollar:    Number(this.form.qarz_dollar || 0),
          currency_mode:  this.form.currency_mode || 'som',
          nasiya_date:    this.form.nasiya_date || null,
          sklad_id:       Number(sklad_id),
          price_type:     this.saleType,
          master_percent: this.masterPercent,
          master_summa:   this.masterSumma,
          product_summa:  this.productSumma,
          summa:          this.totalSum,
          pay_type_id:    1,
          services,
          items,
        };

        await axios.post('api/v1/service-sale', payload);
        this.showReceipt();
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Serverda xato"));
      } finally {
        this.loading = false;
      }
    },

    // ============== KECHIKTIRILGAN (PARKED / HOLD) SAVDOLAR ==============

    async fetchParked() {
      try {
        const res = await axios.get('api/v1/parked-sale');
        this.parkedList = res.data || [];
      } catch (e) { this.parkedList = []; }
    },

    openParkedModal() {
      this.fetchParked();
      this.$refs.parkedModal.show();
    },

    // Joriy POS holatini saqlab, yangi savdoga tozalash
    async parkSale() {
      if (this.cart.length === 0) return alert("Savatcha bo'sh!");

      this.parking = true;
      try {
        // To'liq POS holatini snapshot qilamiz (mijoz, usta, mashina, izoh, to'lovlar)
        const snapshot = {
          cart: this.cart,
          form: this.form,
          saleType: this.saleType,
          masterPercent: this.masterPercent,
        };

        await axios.post('api/v1/parked-sale', {
          kontragent_id:  this.form.kontragent_id,
          master_user_id: this.form.master_user_id,
          car_number:     this.form.car_number,
          comment:        this.form.comment,
          summa:          this.totalSum,
          payload:        JSON.parse(JSON.stringify(snapshot)),
        });

        this.resetPos();
        await this.fetchParked();
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Saqlashda xato"));
      } finally {
        this.parking = false;
      }
    },

    // Kechiktirilgan savdoni davom ettirish — holatni tiklab, parked yozuvni o'chirish
    async resumeParked(id) {
      // Joriy savatcha bo'sh bo'lmasa, ogohlantirish (ustiga yozilmasligi uchun)
      if (this.cart.length > 0 &&
          !confirm("Joriy savatcha tozalanadi va kechiktirilgan savdo yuklanadi. Davom etilsinmi?")) {
        return;
      }

      this.parkBusyId = id;
      try {
        const res = await axios.get(`api/v1/parked-sale/id/${id}`);
        const payload = res.data && res.data.payload;
        if (!payload) throw new Error('Bo\'sh ma\'lumot');

        // Holatni tiklash
        this.cart = Array.isArray(payload.cart) ? payload.cart : [];
        this.form = { ...this.form, ...(payload.form || {}) };
        this.saleType = payload.saleType || 'chakana';
        this.masterPercent = Number(payload.masterPercent) || 0;

        // Mijoz bog'liq ma'lumotlarni yangilash (qarz + mashinalar) — saleType ni buzmasdan
        if (this.form.kontragent_id) {
          this.fetchClientDebt(this.form.kontragent_id);
          this.fetchClientCars(this.form.kontragent_id);
        } else {
          this.clientDebt = 0;
          this.clientDebtSom = 0;
          this.clientDebtDollar = 0;
          this.clientCars = [];
        }

        // Parked yozuvni o'chirib, ro'yxatni yangilash
        await axios.delete(`api/v1/parked-sale/id/${id}`);
        await this.fetchParked();
        this.$refs.parkedModal.hide();
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "Yuklashda xato"));
      } finally {
        this.parkBusyId = null;
      }
    },

    async deleteParked(id) {
      if (!confirm("Ushbu kechiktirilgan savdo o'chirilsinmi?")) return;
      this.parkBusyId = id;
      try {
        await axios.delete(`api/v1/parked-sale/id/${id}`);
        await this.fetchParked();
      } catch (e) {
        alert("Xatolik: " + (e.response?.data?.message || "O'chirishda xato"));
      } finally {
        this.parkBusyId = null;
      }
    },

    // POS ni to'liq tozalab, yangi savdoga tayyorlash
    resetPos() {
      this.clearAll();
      this.form.kontragent_id  = null;
      this.form.master_user_id = null;
      this.form.car_number     = '';
      this.form.comment        = '';
      this.masterPercent       = 0;
      this.clientDebt          = 0;
      this.clientDebtSom       = 0;
      this.clientDebtDollar    = 0;
      this.clientCars          = [];
      this.saleType            = 'chakana';
    },
  },
};
</script>

<style scoped>
.pos-container {
  background-color: #f4f7f9;
  min-height: 100vh;
}

/* Kechiktirilganlar ro'yxati tugmasi */
.btn-park-list {
  background: #fff;
  border: 1.5px solid #fcd34d;
  color: #b45309;
  font-weight: 700;
  font-size: 0.85rem;
  padding: 6px 16px;
  border-radius: 10px;
  transition: 0.15s;
}
.btn-park-list:hover {
  background: #fffbeb;
  border-color: #f59e0b;
}

/* Kichik ekranlarda savatcha ostida turadi, tepaga sticky bo'lmaydi */
@media (max-width: 991px) {
  ::v-deep .cart-sidebar {
    height: auto !important;
    max-height: none !important;
    position: static !important;
    margin-top: 15px;
  }
  ::v-deep .cart-sidebar .cart-items {
    max-height: 300px;
  }
  ::v-deep .cart-sidebar .cart-summary {
    max-height: none;
  }
}

@media (max-width: 575px) {
  .pos-container {
    padding: 8px !important;
  }
}
</style>
